import { useRef } from 'react';
import { OverlayTrigger, Tooltip as BTooltip } from 'react-bootstrap';

import Helper from '../../helpers/Helper';

interface IProps {
    content: any;
    location?: 'top' | 'right' | 'bottom' | 'left';
    children: any
}

const Tooltip = ({ location = 'top', children, content }: IProps) => {

    const id = useRef(Helper.generateGuid());

    return (
        <OverlayTrigger
            placement={location}
            overlay={
                <BTooltip id={`tooltip-${id.current}`}>
                    {content}
                </BTooltip>
            }>
            {children}
        </OverlayTrigger>
    );
};

export default Tooltip;